<template>
  <div style="height: 100%" class="histo">
    <v-card flat :height="chatHeight">
      <v-card
        width="320"
        height="100%"
        style="z-index: 1000000;position:absolute"
        absolute
      >
        <v-toolbar flat class="white" dense extended>
          <v-toolbar-title></v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
        <v-form >
          <v-container left>
            <v-layout>
              <v-flex>
                  <v-select
                  :items="default_motif"
                  v-model="convMotif"
                  label="Motif de la conversation"
                  v-on:change="showValidButton"
                  ></v-select>

                  <v-select
                  :items="default_qualif"
                  v-model="convQualif"
                  label="Qualifier la conversation"
                  v-on:change="showValidButton"
                  ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
        <v-btn color="primary" left v-if="validButton" @click="submitEdit()">{{ $t('save') }}</v-btn>
      </v-card>

      <v-toolbar 
        v-if="toolbar"
        class="primary"
        dark dense extended
        :class="{'histo__navigation--opened': true}"
      >
        <v-toolbar-side-icon></v-toolbar-side-icon>
        <v-toolbar-title class="white--text">Conversation n° {{ params }}</v-toolbar-title>
        <div class="white--text subheading" slot="extension">
          <v-tooltip right >
            <span slot="activator" class="mr-3">
              <v-icon dark>access_time</v-icon>
              {{ dateConv }}
            </span>
            <span>Date</span>
          </v-tooltip>
          <v-tooltip right >
            <span slot="activator">
              <v-icon dark>timer</v-icon>
              {{ dureeConv }}
            </span>
            <span>Durée totale</span>
          </v-tooltip>
          <v-tooltip right >
            <span slot="activator">
            <v-icon dark right>chat_bubble_outline</v-icon>
            {{ nbBulles }}
            </span>
            <span>Nb de boutons cliqués / messages saisis</span>
          </v-tooltip>
        </div>
        <v-spacer></v-spacer>
      </v-toolbar>

      <main
        :class="{
          'histo__navigation--opened vb': true,
          'histo__main--toolbar vb': toolbar,
          'histo__main--no-toolbar vb': !toolbar,
        }"
        ref="contentChat"
        id="contentChat"
        style="height: 100%;"
        v-bar
      >
        <div
          grid-list-sm
          fluid
          class="histo__main--scroll"
        >
          <v-card v-if="loading" :height="chatHeight">
            <v-card-text class="text-xs-center pt-5">
              <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
            </v-card-text>
          </v-card>

          <div
            v-else-if="visiteurs[0]"
            height="100%"
          >
            <transition name="slide-x-reverse-transition" mode="out-in">
              <v-layout row wrap   style="width: 100%;">
                <!-- <template v-for="(msg, i) in visiteurs[0].chats[0].messages"> -->
                  <!-- Indication du jour du chat -->
                  <v-flex xs12 v-if="msg.anotherDay" class="text-xs-center sticky" :key="msg.date">
                    <div secondary class="dateMessageChat">{{ msg.anotherDay }}</div>
                  </v-flex>
                  <v-flex xs12 v-for="(msg, i) in visiteurs[0].chats[0].messages" :key="i">
                    <!-- message VISITEUR -->
                    <v-layout v-if="msg.auteur == 'Visiteur'" row>
                      <v-flex xs2 class="text-xs-right ma-2">
                        <wz-avatar :username="msg.agentName" :src="`${domaine}/public/media/user/small/_avatar.jpg`" size="35px"></wz-avatar>
                      </v-flex>
                      <v-flex xs10 v-if="intentId === msg.id">
                        <v-card
                          :class="[
                            'white--text',
                            'histo__bubble',
                            'histo__bubble--agent',
                            'blue',
                            'pointer'
                          ]"
                          @click.native="changeSection"
                        >
                          <v-card-text class="pa-2 ma-2">
                            <div>
                              <span v-if="msg.text">{{ msg.text }}</span>
                            </div>
                            <small class="font-italic text-right">Intention à vérifier <small>(cliquez pour éditer)</small></small>
                          </v-card-text>
                        </v-card>
                        <small>{{ msg.date }} • {{ msg.type }} {{ msg.value }} • Entité : {{ msg.entity }}</small>
                      </v-flex>
                      <v-flex xs10 v-else>
                        <v-card
                          :class="[
                            'white--text',
                            'histo__bubble',
                            'histo__bubble--agent',
                            colorChatAgent,
                            'pointer'
                          ]"
                          @click.native="msg.text !== 'tfstart' && msg.text !== 'tfstartwithcookie' && changeDialogIntent(msg.id)"
                        >
                          <v-card-text class="pa-2 ma-2">
                            <div>
                              <span v-if="msg.text">{{ msg.text }}</span>
                            </div>
                            <small class="font-italic text-right">{{ msg.comment }}</small>
                          </v-card-text>
                        </v-card>
                        <small>{{ msg.date }} • {{ msg.type }} {{ msg.value }} • Entité : {{ msg.entity }} </small>
                      </v-flex>
                      <v-flex md3 class="hidden-sm-and-down" ></v-flex>
                    </v-layout>
                    <!-- message AGENT -->
                    <v-layout v-else row>
                      <v-flex md3 class="hidden-sm-and-down"></v-flex>
                      <v-flex xs10 md8 class="text-xs-right">
                        <v-card
                          :class="['white--text', 'histo__bubble', 'histo__bubble--visitor', colorChatVisiteur]"
                        >
                          <v-card-text class="text-xs-right pa-2">
                            <v-icon
                              v-if="false"
                              :color="colorChatVisiteur"
                              class="corner corner--visitor"
                              unselectable="on"
                              onselectstart="return false;" 
                              onmousedown="return false;"
                            >arrow_drop_down</v-icon>
                            <div class="mr-4">
                              <span v-if="msg.text">{{ formatText(msg.text) }}</span>
                              <img v-else :src="msg.attachment" alt="Image indisponible">
                            </div>
                          </v-card-text>
                        </v-card>
                        <small>{{ msg.date }}</small>
                      </v-flex>
                      <v-flex xs2 ml-1>
                        <wz-avatar :username="'#' + visitorSelected" size="35px"></wz-avatar>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                <!-- </template> -->
              </v-layout>
            </transition>
          </div>
          <v-alert v-else color="blue" icon="info" value="true" outline>
            {{ $tc('chats', 0) | cap }}
          </v-alert>
        </div>
      </main>
    </v-card>
  </div>
</template>

<style>
.histo__main--scroll {
  max-height: -webkit-fill-available;
}
.pointer {
  cursor: pointer;
}
</style>

<script>
import _ from 'lodash'
import moment from 'moment'
import { DOMAINE } from '../../constants'
export default {
  props: {
    params: {
      type: String,
      required: true
    },
    toolbar: {
      type: Boolean,
      default: true
    },
    colorChatAgent: {
      type: String,
      default: 'teal'
    },
    colorChatVisiteur: {
      type: String,
      default: 'blue-grey darken-2'
    },
    chatHeight: {
      type: String,
      default: '600px'
    },
    scroll: {
      type: Boolean,
      default: false
    },
    intentId: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      domaine: DOMAINE,
      detailConver: true,
      chatId: null,
      visiteurs: [],
      allChats: [],
      switchChat: false,
      loading: true,
      loadingHisto: false,
      loadingExportChats: false,
      loadingExportChat: false,
      visitorSelected: '',
      dateConv: '',
      dureeConv: '00:00',
      nbBulles: 0,
      validButton: false,
      convMotif: '',
      default_motif: [
        { text: 'Pas de motif', value: '' },
        { text: _.upperFirst(this.$t('support')), value: 'support' },
        { text: _.upperFirst(this.$t('lead')), value: 'lead' },
        { text: _.upperFirst(this.$tc('sales', 1, { count: '' })), value: 'sale' },
        { text: _.upperFirst(this.$t('estimate')), value: 'devis' },
        { text: _.upperFirst(this.$t('reservation')), value: 'resa' },
        { text: _.upperFirst(this.$t('contact')), value: 'contact' }
      ],
      convQualif: '',
      default_qualif: [
        { text: 'Pas de qualificatif', value: '' },
        { text: 'Conversation très interessante', value: 'tres' },
        { text: 'Conversation pas interessante', value: 'pas' },
        { text: 'Conversation à surveiller', value: 'watch' },
        { text: 'Conversation à exclure des stats', value: 'exclude' }
      ]
    }
  },

  created () {
    this.loading = true
    this.loadingHisto = true
    this.getChats()
    let listeMotifs = [{ text: 'Pas de motif', value: '' }]
    let customLead = this.$store.state._Sites.siteSelected.DSK_CUSTOM_LEAD_FORM
    if (customLead !== '') {
      for (let i = 0; i < customLead.motifs.length; ++i) {
        let label = customLead.motifs[i]
        if (label === 'support') {
          label = 'Support'
        } else if (label === 'lead') {
          label = 'Prospect qualifié'
        } else if (label === 'sale') {
          label = 'Vente'
        } else if (label === 'resa') {
          label = 'Réservation'
        } else if (label === 'devis') {
          label = 'Devis'
        } else if (label === 'contact') {
          label = 'Contact'
        }
        listeMotifs.push({
          text: label,
          value: customLead.motifs[i]
        })
      }
      if (listeMotifs.length !== 0) {
        this.default_motif = listeMotifs
      } else {
        this.default_motif = []
      }
    }
    this.default_motif = listeMotifs
  },

  computed: {
  },

  methods: {
    /**
     * Recupère les éléments de conversation
     */
    getChats () {
      this.nbBulles = 0
      this.dureeConv = '00:00'
      this.loadingHisto = true
      this.loading = true
      this.axios
        .get('get/bot_conversation.php?convid=' + this.params)
        .then(response => {
          this.visitorSelected = this.params
          // vide le tableau des visiteurs
          this.visiteurs = _.isArray(response.data) ? response.data : []
          _.each(this.visiteurs, visiteur => {
            // visiteur.duration = moment.duration(visiteur.duration, 'seconds').format('h [h] m [m] s [s]')
            // visiteur.averageResponse = moment.duration(visiteur.averageResponse, 'seconds').format('h [h] m [m] s [s]')
            this.convMotif = visiteur.motif
            this.convQualif = visiteur.qualif

            // chaque conversation
            _.each(visiteur.chats, conversation => {
              var firstMsgDate = ''
              // chaque message de la conversation
              _.each(conversation.messages, message => {
                if (message.agentName === 'undefined' || message.agentName === '') {
                  message.agentName = 'Chatbot'
                }
                if (firstMsgDate === '') {
                  firstMsgDate = moment.unix(message.date)
                }

                let date = moment.unix(message.date)
                message.date = date.format('LTS')
                this.dateConv = date.format('L')

                this.dureeConv = moment.duration(date.diff(firstMsgDate, 'seconds'), 'seconds').format('h [h] m [m] s [s]')

                this.nbBulles++
              })
            })
          })
        })
        .catch(errors => {
          this.loading = false
          this.loadingHisto = false
        })
        .then(_ => {
          this.loading = false
          this.loadingHisto = false
        })
    },
    changeSection () {
      this.$emit('changeSection')
    },
    changeDialogIntent (id) {
      this.$emit('changeDialogIntent', id)
    },
    showValidButton () {
      this.validButton = true
    },
    submitEdit () {
      this.validButton = false

      let dataToPost = new window.FormData()
      dataToPost.append('convid', this.params)
      dataToPost.append('motif', this.convMotif)
      dataToPost.append('qualif', this.convQualif)
      this.axios.post('post/bot_edit_conv.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        // this.$emit('updateLead', this.leadDialog)
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
      })
      .catch(() => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
      })
    },
    formatText (msg) {
      /* let messagetoshow = ''
      let words = msg.split('<br>')
      for (let i = 0; i < words.length; ++i) {
        messagetoshow += words[i] + '<br>'
      } */
      return msg
    }
  },

  updated () {
  },

  watch: {
    params (val, oldVal) {
      this.getChats()
    },
    detailConver (val, oldVal) {
      console.log('detailConver')
      console.log(val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzConvTrainingBot.vue